<template>
</template>

<script>

export default {
  name: "ResetCellPhonePassword",
};
</script>
<style scoped>

</style>